/*  Music Forecast — カート/メニューのドロワーを開くとプレイヤーが操作できなくなる問題の修正
    mf-player-drawer-fix v1.0 / 2026-09-19

    症状
      カートドロワー（メニュー・在庫通知・検索ドロワーも同じ）を開いている間、
      画面下のプレイヤーは見えているのに押せない。閉じる・一時停止・曲送り・シークが全部効かない。

    原因
      テーマ（Label 3.6.2）はドロワーを開くとき、そのドロワーの兄弟要素すべてに inert を付けて
      背後を不活性にする。プレイヤー（#mf-player）と YouTube の受け皿（#mf-yt）は、ページを移っても
      音を切らさないために <body> 直下に置いてあるので、この「兄弟」に巻き込まれる。
      inert が付いた要素は pointer-events:none になるため、z-index 9999 で最前面に描かれていても
      クリックが一切通らない。
        テーマ側の該当コード（theme.min.js）:
          u.forEach(function(e){ e.getAttribute("aria-live") || e.setAttribute("inert", !0) })

    対策（PART 1）
      上のコードに「aria-live を持つ要素は inert にしない」という除外条件があるので、それに乗る。
      #mf-player と #mf-yt に aria-live="off" を付けるだけ。"off" は「読み上げで通知しない」という
      意味なので、スクリーンリーダー側への副作用もない。テーマのファイルは触らない。

    おまけ（PART 2）
      ドロワーは「外側をクリックしたら閉じる」（Alpine の @click.away）。プレイヤーは外側なので、
      一時停止を押しただけでカートまで閉じてしまう。プレイヤー内のクリックだけ「内側」とみなさせる。
      この挙動が不要なら PART 2 のブロックを丸ごと削除してよい（PART 1 だけで本題は直る）。

    設置
      テーマ → コードを編集 → Assets → 新しいアセットを追加 → mf-player-drawer-fix.js
      layout/theme.liquid の </body> 直前に次の1行:
        <script src="{{ 'mf-player-drawer-fix.js' | asset_url }}" defer></script>

    戻し方
      その1行を消すだけ（属性はページを読み込み直せば消える）
*/
(function () {
  'use strict';

  var TARGETS = ['mf-player', 'mf-yt'];
  var INSIDE  = '#mf-player, #mf-yt';

  /* ---------- PART 1 : inert の対象から外す ---------- */

  function exempt() {
    for (var i = 0; i < TARGETS.length; i++) {
      var el = document.getElementById(TARGETS[i]);
      if (!el) continue;
      if (!el.getAttribute('aria-live')) el.setAttribute('aria-live', 'off');
      if (el.hasAttribute('inert')) el.removeAttribute('inert');              // 既に付いている分を外す
      if (el.getAttribute('aria-hidden') === 'true') el.removeAttribute('aria-hidden');
    }
  }

  /* ---------- PART 2 : プレイヤー内のクリックでドロワーを閉じさせない ---------- */

  var AWAY = '[\\@click\\.away\\.prevent],[x-on\\:click\\.away\\.prevent],[\\@click\\.away],[x-on\\:click\\.away]';
  var nativeContains = Node.prototype.contains;

  function shield() {
    var els;
    try { els = document.querySelectorAll(AWAY); } catch (e) { return; }
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.__mfShielded) continue;
      el.__mfShielded = true;
      // Alpine の away ハンドラは el.contains(e.target) だけで内外を判定している。
      // プレイヤー内のノードも「内側」と答えることで、ドロワーは閉じなくなる。
      el.contains = function (n) {
        if (nativeContains.call(this, n)) return true;
        return !!(n && n.nodeType === 1 && n.closest && n.closest(INSIDE));
      };
    }
  }

  /* ---------- 起動 ---------- */

  var queued = false;
  function run() {
    if (queued) return;                                                      // 1フレームにつき1回でよい
    queued = true;
    requestAnimationFrame(function () { queued = false; exempt(); shield(); });
  }

  function start() {
    exempt(); shield();
    // #mf-player は最初の再生時に body 直下へ作られるので、body の直下だけ見張れば足りる
    try {
      new MutationObserver(run).observe(document.body, { childList: true });
    } catch (e) {}
    // ソフトナビでドロワーのセクションが差し替わったとき用
    window.addEventListener('label:section:hasmutated', run);
    // 保険：プレイヤーに触れた瞬間に、まだ守られていないドロワーがあれば守る
    document.addEventListener('pointerdown', function (e) {
      var t = e.target;
      if (t && t.nodeType === 1 && t.closest && t.closest(INSIDE)) { exempt(); shield(); }
    }, true);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();